import { combineReducers } from 'redux';

import { loadersReducer } from './loadersSlice';
import { modalsReducer } from './modalsSlice';

export const serviceReducer = combineReducers({
  loaders: loadersReducer,
  modals: modalsReducer,
});
